import Icon, { IconProps } from './Icon';

import DownOutlinedIcon from '../../../assets/icons/chevron-down.svg?react';

const DownOutlined: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <DownOutlinedIcon />
    </Icon>
  );
};

export default DownOutlined;
